module.exports = __webpack_public_path__ + "static/media/img2-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_suelo/K/img2-1.png
// module id = 2343
// module chunks = 3